<template>
  <div>
    <el-table
      class="trade-pair-table"
      :data="tradePairList"
      :row-key="() => Math.random()">
      <el-table-column
        prop="pair"
        label="交易对">
      </el-table-column>
      <el-table-column
        prop="defaultPrecision"
        label="价格精度">
      </el-table-column>
      <el-table-column
        prop="amountPrecision"
        label="数量精度">
      </el-table-column>
      <el-table-column prop="bidFeeRate" label="交易买费率"/>
      <el-table-column prop="askFeeRate" label="交易卖费率"/>
      <el-table-column label="是否展示">
        <template slot-scope="scope">
          <el-switch active-color="#13ce66" :value="scope.row.shouldDisplay" disabled></el-switch>
        </template>
      </el-table-column>
      <el-table-column
        label="是否支持交易">
        <template slot-scope="scope">
          <el-switch
            active-color="#13ce66"
            :value="scope.row.supportTrade"
            disabled>
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column
        label="是否支持下买单">
        <template slot-scope="scope">
          <el-switch
            active-color="#13ce66"
            :value="scope.row.supportBid"
            disabled>
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column
        label="最早买单时间">
        <template slot-scope="scope">
          <span v-if="scope.row.earliestBidTime">
            <span v-bind:class="{unabletime: scope.row.earliestBidTime > (new Date()).getTime()}">{{scope.row.earliestBidTime | moment}}</span>
          </span>
        </template>
      </el-table-column>
      <el-table-column
        label="是否支持下卖单">
        <template slot-scope="scope">
          <el-switch
            active-color="#13ce66"
            :value="scope.row.supportAsk"
            disabled>
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column
        label="最早卖单时间">
        <template slot-scope="scope">
          <span v-if="scope.row.earliestBidTime">
            <span v-bind:class="{unabletime: scope.row.earliestAskTime > (new Date()).getTime()}">{{scope.row.earliestAskTime | moment}}</span>
          </span>
        </template>
      </el-table-column>
      <el-table-column
        label="是否属于OCA交易区">
        <template slot-scope="scope">
          <el-switch
            active-color="#13ce66"
            :value="scope.row.oca"
            disabled>
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column
        label="是否风险系数高">
        <template slot-scope="scope">
          <el-switch
            active-color="#ff4949"
            :value="scope.row.highRisk"
            disabled>
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column
        label="操作">
        <template slot-scope="scope">

          <el-button
            type="primary"
            icon="el-icon-edit"
            circle
            size="small"
            @click="handleModify(scope.row)"/>

          <el-button
                  type="danger"
                  icon="el-icon-delete"
                  circle
                  size="small"
                  @click="handleRemove(scope.row.pair)"/>

          <el-button
            v-if="!scope.row.supportTrade"
            size="small"
            @click="handleTransaction(scope.row.pair)"
          >
            交易对撤单
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :size="pagination.size"
      :page="pagination.page"
      :total="totalCount"
      @pageChanged="handlePageChanged"
      >
    </pagination>

  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex';
import Pagination from 'components/pagination';
import SortableMixin from 'mixins/SortableMixin';

export default {
  name: 'TradePairList',
  mixins: [SortableMixin],
  components: {
    Pagination
  },
  data() {
    return {
      sortable: '.trade-pair-table',
        editingPair: false,
        pairConfig: {},
        rules: {
        }
    };
  },
  computed: {
    ...mapGetters('tradePairSetting', ['tradePairList']),
    ...mapState('tradePairSetting', ['pagination', 'totalCount'])
  },
  methods: {
    ...mapMutations('tradePairSetting', ['toggleDetailDialogVisible','setPairConfigDetail']),
    ...mapActions('tradePairSetting', [
      'updateTradeStatus',
      'remove',
      'transaction',
      'updateDefaultPrecision',
      'updateSort'
    ]),
    handleStatusChange(pair, status) {
      const message = `确认要${status ? '开启' : '关闭'}交易功能吗？`;

      this.$confirm(message, '提示', { type: 'warning ' }).then(() => {
        this.updateTradeStatus({ pair, status }).then(() => {
          this.$message.success('操作成功！');
          this.$emit('refresh');
        });
      });
    },
    handleRemove(pair) {
      this.$confirm('确认要删除该交易对吗？', '提示', { type: 'warning' }).then(
        () => {
          this.remove(pair).then(() => {
            this.$message.success('删除成功！');
            this.$emit('refresh');
          });
        }
      );
    },
    handleTransaction(pair) {
      this.$confirm('确认要撤销该交易对下的所有订单么？', '提示', {
        type: 'warning'
      }).then(() => {
        this.transaction(pair).then(() => {
          this.$message.success('撤单成功！');
          this.$emit('refresh');
        });
      });
    },
    handlePageChanged(pagination) {
      this.$emit('refresh', pagination);
    },
    handlePrecisionChange(pair) {
      this.$prompt('请输入默认精度', '提示', {
        inputValidator: value => {
          return !value || !value.trim() ? '请输入默认精度' : true;
        }
      }).then(({ value }) => {
        this.updateDefaultPrecision({ pair, precision: Number(value) }).then(
          () => {
            this.$message.success('操作成功！');
            this.$emit('refresh');
          }
        );
      });
    },
    handleModify(pairConfig) {
      this.toggleDetailDialogVisible(true);
      this.setPairConfigDetail(pairConfig);
    },
    handleSave() {
      this.editingPair = false;
    },
    closeDialog() {
      this.editingPair = false;
      // this.$refs['pairConfig'].resetFields();
    },
    onSort(evt) {
      const { oldIndex, newIndex } = evt;
      const { page, size } = this.pagination;

      if (oldIndex !== newIndex) {
        const pair = this.tradePairList[oldIndex].pair;

        this.updateSort({
          pair,
          orderNo: (page - 1) * size + newIndex + 1
        }).then(() => {
          this.$message.success('更新成功！');
          this.$emit('refresh');
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
  .el-button {
    margin: 0px 5px 5px 0px;
  }
  .unabletime {
    color: #ff4949;
  }
</style>
